import styled from 'styled-components';

import { SkeletonLoader } from '@pkg/components/SkeletonLoader';

export const GroupSkeletonWidth = styled.div`
    width: 100%;
`;

export const GroupSkeletonWrapper = styled.div`
    margin: 0 20px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        margin: 0;
    }
`;

export const GroupSkeletonHeader = styled.div`
    width: 100%;
    display: flex;
    gap: 20px;
    align-items: center;

    @media (min-width: ${({ theme }) => theme.breakpoints.tabletSmall}) {
        gap: 30px;
        align-items: flex-start;
    }
`;

export const SkeletonGroupMembersDesktop = styled.div`
    flex-direction: column;
    gap: 10px;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        display: none;
    }
`;

export const SkeletonGroupMembersMobile = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 10px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        display: none;
    }
`;

export const GroupSkeletonAvatar = styled.div`
    display: flex;
    flex-shrink: 0;
`;

export const SkeletonGroupAvatarSkeleton = styled(SkeletonLoader)`
    width: 32px;
    height: 32px;
    border-radius: 100%;

    @media (min-width: ${({ theme }) => theme.breakpoints.tabletSmall}) {
        width: 90px;
        height: 90px;
    }
`;

export const GroupSkeletonName = styled.div`
    display: flex;
    flex-direction: column;
    align-self: center;
    gap: 10px;
    width: 100%;
`;

export const SkeletonGroupNameSkeleton = styled(SkeletonLoader)`
    width: 50%;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        width: 30%;
        height: 25px;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.tabletSmall}) {
        width: 20%;
        height: 30px;
    }
`;

export const SkeletonGroupDescriptionSkeleton = styled(SkeletonLoader)`
    width: 70%;
    height: 15px;

    @media (min-width: ${({ theme }) => theme.breakpoints.tabletSmall}) {
        width: 60%;
    }
`;

export const SkeletonGroupMembers = styled.div`
    display: flex;
    gap: 10px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        margin-top: 10px;
    }
`;

export const SkeletonGroupMemberSkeleton = styled(SkeletonLoader)`
    width: 85px;

    @media (min-width: ${({ theme }) => theme.breakpoints.tabletSmall}) {
        height: 24px;
        width: 120px;
    }
`;

export const GroupSkeletonSubscribeSkeleton = styled(SkeletonLoader)`
    width: 120px;
    height: 35px;
    border-radius: 34px;
`;

/* Single Group
---------------------------------------------- */

export const GroupSkeletonList = styled.div`
    padding-bottom: 100px;
`;

export const GroupSkeletonSubscribeMobile = styled.div`
    display: flex;
    align-self: flex-end;
    margin-bottom: 20px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        display: none;
    }
`;

export const GroupAvatarSkeleton = styled(SkeletonLoader)`
    width: 40px;
    height: 40px;
    border-radius: 100%;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        width: 135px;
        height: 135px;
    }
`;

export const GroupNameSkeleton = styled(SkeletonLoader)`
    width: 80%;
    height: 30px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        width: 60%;
        height: 50px;
    }
`;

export const GroupDescriptionSkeleton = styled(SkeletonLoader)`
    width: 90%;
    height: 20px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        width: 50%;
    }
`;

export const GroupSkeletonSubscribeSingle = styled.div`
    display: none;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        display: flex;
        align-self: flex-end;
    }
`;
